import { AxiosInstance } from 'axios';
import { CreateUserFormParams } from '../../../views/admin/create-user/CreateUserView';
import { CheckPasswordParams } from '../../../views/dashboard/my-page/CheckPasswordView';
import { GetListUserExchangeParams, UserDTO, UserExchangeDTO } from '../../types/apiType';
import { PaginatedConnection, PaginatedQueryParams, PaginationConnection, PaginationQueryParams } from '../../types/common';
import PythonApiClient from '../../pythonApiClient';

export default class UserService {
  constructor(private axios: AxiosInstance) {}

  checkPassword = async (value: CheckPasswordParams): Promise<string> => {
    const { data } = await this.axios.post('user/me/check-password', value);
    return data;
  };

  updateMyDetail = async (params: CreateUserFormParams): Promise<null> => {
    const { data } = await this.axios.put('user/me', params);
    return data;
  };

  getMyDetail = async (): Promise<UserDTO> => {
    const { data } = await this.axios.get('user/me');
    return data;
  };

  getUserExchangeListAdmin = async (params?: GetListUserExchangeParams): Promise<PaginatedConnection<UserExchangeDTO>> => {
    const { data } = await this.axios.get('user/exchange-item', { params });
    return data;
  };

  exchangeItem = async (itemId: string): Promise<null> => {
    const { data } = await this.axios.post('user/exchange-item', { itemId });
    return data;
  };

  updateUserExchange = async (body: { id: string; status: string }): Promise<null> => {
    const { data } = await this.axios.put(`user/exchange-item/${body.id}`, { status: body.status });
    return data;
  };

  updateUserAdmin = async (body: { id: string; params: CreateUserFormParams }): Promise<null> => {
    const { data } = await this.axios.put(`user/${body.id}`, body.params);
    return data;
  };

  createUserAdmin = async (params: CreateUserFormParams): Promise<string> => {
    const { data } = await this.axios.post('user', params);
    return data;
  };

  // eslint-disable-next-line class-methods-use-this
  createPythonPoint = async (params: { id: string; point: string }): Promise<string> => {
    const { data } = await PythonApiClient.put('createNotif', { params });
    return data;
  };

  passVerifyUserAdmin = async (id: string): Promise<null> => {
    const { data } = await this.axios.put(`user/pass-verify/${id}`);
    return data;
  };

  getUserByIdAdmin = async (id: string): Promise<UserDTO> => {
    const { data } = await this.axios.get(`user/${id}`);
    return data;
  };

  getUserListAdmin = async (params?: PaginatedQueryParams): Promise<PaginatedConnection<UserDTO>> => {
    const { data } = await this.axios.get('user', { params });
    return data;
  };

  getUserListForAnalytics = async (params?: PaginatedQueryParams): Promise<any> => {
    const { data } = await this.axios.get('user', { params, timeout: 999999999 } as any);
    // const round = function(num, decimalPlaces = 0) {
    //   if (num < 0)
    //       return -round(-num, decimalPlaces);
    //   const p = 10 ** decimalPlaces;
    //   const n = num * p;
    //   const f = n - Math.floor(n);
    //   const e = Number.EPSILON * n;
  
    //   // Determine whether this fraction is a midpoint value.
    //   return (f >= .5 - e) ? Math.ceil(n) / p : Math.floor(n) / p;
    // }
    console.log("DATA",data);
    if(params.complete) {
      console.log("DATA",data);
      const dataList = data.list;
      
      // dataList.forEach((user)=>{
        // user.totalCompletedImages = 0;
        // user.totalScore = 0;
        // user.totalGoalCompleted = 0;
        // user.totalGoalNotCompleted = 0;
        // user.totalTime = 0;
        // user.totalProject = 0;
        // user.averageGoalCompleted = 0;
        // user.averageGoalNotCompleted = 0;
        // user.averageTime = 0;
        // user.userProject.forEach((userProject)=>{
        //   if(userProject.totalCompletedImages > 0) {
        //     user.totalProject+=1;
        //     user.totalCompletedImages+=userProject.totalCompletedImages;
        //     user.totalScore+=userProject.score;
        //     user.totalGoalCompleted += userProject.totalGoalCompleted;
        //     user.totalGoalNotCompleted += userProject.totalGoalNotCompleted;
        //     user.totalTime += userProject.totalTime;
        //   }
        // })
        // user.averageScore = user.totalProject > 0 ? round(user.totalScore / user.totalProject,2) : 0;
        // user.averageGoalCompleted = user.totalProject > 0 ? round(user.totalGoalCompleted / user.totalProject,2): 0;
        // user.averageGoalNotCompleted = user.totalProject > 0 ? round(user.totalGoalNotCompleted / user.totalProject,2): 0;
        // user.averageTime = user.totalProject > 0 ? round(user.totalTime,2) / user.totalProject: 0;
      // })

      // dataList.sort((a,b) => {return (+(a.totalCompletedImages < b.totalCompletedImages) || +(a.totalCompletedImages === b.totalCompletedImages) - 1) ||
      //   (+(a.averageScore < b.averageScore) || +(a.averageScore === b.averageScore) - 1);
      // });
      return {list:dataList, count: data.totalCount};
      
    }
    return data;
  };

  getUserInfinityListAdmin = async (params?: PaginationQueryParams): Promise<PaginationConnection<UserDTO>> => {
    // console.log(params);
    const { data } = await this.axios.get('user/infinity', { params });
    return data;
  };

  deleteUserAdmin = async (id: string): Promise<null> => {
    const { data } = await this.axios.delete(`user/${id}`);
    return data;
  };

  checkIsAddCategoryDefault = async (): Promise<boolean> => {
    const { data } = await this.axios.get(`user/check-add-default`);
    return data;
  };

  updateIsAddCategoryDefault = async (): Promise<null> => {
    const { data } = await this.axios.put(`user/check-add-default`);
    return data;
  };

  getActivityPlox = async ():  Promise<any[]> =>{

    const groupBy = function(xs, key) {
      return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    };
    const data = await this.axios.get('activity');
    const { data : result } = await PythonApiClient.put('tesBoundingScoreAll2', data, { timeout: 10000000 });
    
    const round = function(num, decimalPlaces = 0) {
      if (num < 0)
          return -round(-num, decimalPlaces);
      const p = 10 ** decimalPlaces;
      const n = num * p;
      const f = n - Math.floor(n);
      const e = Number.EPSILON * n;
  
      // Determine whether this fraction is a midpoint value.
      return (f >= .5 - e) ? Math.ceil(n) / p : Math.floor(n) / p;
    }

    const groupByUsers =  groupBy(result,"username");
    Object.keys(groupByUsers).forEach((e)=>{groupByUsers[e] = {dates:groupBy(groupByUsers[e],"date")}});
    Object.keys(groupByUsers).forEach((e)=>{Object.keys(groupByUsers[e].dates).forEach((e2)=>{groupByUsers[e].dates[e2] = {"length":groupByUsers[e].dates[e2].length,"average":round(groupByUsers[e].dates[e2].reduce((a,b)=>{return a+(b.iou ? b.iou : 0)},0)/groupByUsers[e].dates[e2].length,2)}})});
    console.log(groupByUsers);
    
    const arr = [];
    Object.keys(groupByUsers).forEach((e)=>{ 
      const newObj = {username:e,"data":groupByUsers[e], "length":0 , "average":0}; Object.keys(groupByUsers[e].dates).forEach((e2)=> {
        console.log(e2);
        newObj.length += groupByUsers[e].dates[e2].length;
        newObj.average += Math.round(groupByUsers[e].dates[e2].average / Object.keys(groupByUsers[e].dates).length);
      })
      arr.push(newObj);
    });
    // groupByUsers[e].reduce((a,b)=>{a.length += b.length; a.total += b.total; return a;},{"length":0,"total":0, "data":groupByUsers[e]})
    return arr;
  };
}
